module.exports = "<div>\r\n    <h2>Hello Son</h2>\r\n    <md-datepicker #picker></md-datepicker>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/prescribe-vaccination/pick-date.component.html
// module id = ../../../../../src/app/pages/consultation-process/prescribe-vaccination/pick-date.component.html
// module chunks = main